'use client'

import '@/views/digital-banking/digital-banking.css'

import type { ReactNode } from 'react'

import { Col, Container, Row } from 'react-bootstrap'

import iosButton from '@/assets/images/coming-soon/app-store.svg'
import BannerImage from '@/assets/images/coming-soon/AppStore_right.webp'
import googleButton from '@/assets/images/coming-soon/google-button.svg'
import qrcode from '@/assets/images/coming-soon/qr-code.webp'

function InstallApp({
  title = 'Get the MY alrajhi app',
  noDescription = false
}: {
  title?: ReactNode
  noDescription?: boolean
}) {
  return (
    <div id="install-app" className="container install-app">
      <Container fluid className="inward-container">
        <Row>
          <div data-aos="fade-up" data-aos-delay="150">
            <h2 className="heading mb-3">{title}</h2>
          </div>
          <Row className="align-items-center flex-column-reverse flex-lg-row mx-auto">
            <Col className="me-lg-5">
              <div className="col aos-init" data-aos="fade-left" data-aos-delay="150">
                <div className="content-container">
                  <div className="coming-soon-image-container">
                    <img
                      src={qrcode.src}
                      alt="QR Code"
                      className="d-block"
                      width="100%"
                      height="auto"
                    />
                  </div>
                  <div className="qr-content-container">
                    <h3 className="fw-bold">Scan this QR code</h3>
                    <p className="fs-16 fs-14">
                      Use your phone's camera to scan the code and download the app
                    </p>
                  </div>
                </div>
                <Row className="d-flex align-items-center my-3 mx-2">
                  <Col md={5} xs={4}>
                    <div className="divider"></div>
                  </Col>
                  <Col md={2} xs={4}>
                    <h5 className="divider-title">Or</h5>
                  </Col>
                  <Col md={5} xs={4}>
                    <div className="divider"></div>
                  </Col>
                </Row>
                <div className="content-container">
                  <div className="qr-content-container">
                    <h3 className="fw-bold">Download the app</h3>
                    <p className="fs-md-14">
                      Find the MY alrajhi app in the App Store and Google Play.
                    </p>
                    <div className="install-app-buttons">
                      <a
                        href="https://play.google.com/store/apps/details?id=my.com.alrajhibank.wick"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={googleButton.src}
                          alt="Download on Google Play"
                          width="100%"
                          height="auto"
                        />
                      </a>
                      <a
                        href="https://apps.apple.com/my/app/my-alrajhi/id1587293861"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={iosButton.src} alt="Download on iOS" width="100%" height="auto" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col>
              <div className="mb-4 mb-lg-0">
                <img
                  src={BannerImage.src}
                  alt="Hero Image"
                  className="d-block"
                  data-aos="fade-right"
                  data-aos-delay="150"
                  style={{
                    width: '100%'
                  }}
                />
              </div>
            </Col>
          </Row>
          {!noDescription && (
            <>
              <p className="text-start" style={{ color: '#5d6377', fontSize: '15px' }}>
                For your security, please make sure you always install the latest version of the app
                from the App Store <br />
                or Google Play. The app supports the following devices and operating systems:
              </p>
              <ul
                className="text-start"
                style={{
                  listStyleType: 'disc',
                  paddingLeft: '35px',
                  color: '#5d6377',
                  fontSize: '15px'
                }}
              >
                <li>iPhones with iOS 16 or above</li>
                <li>Androids with Android 11 or above</li>
              </ul>
            </>
          )}
        </Row>
      </Container>
    </div>
  )
}

export default InstallApp
